import moment from 'moment';
import { OperatorKey, QueueKey } from 'flow/types/EntityKeys';
import wrappedLocalStorage from 'flow/utils/local-storage-utils';
import { ActiveProfile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
const SELECTED_OPERATOR = 'supervisorSelectedOperator';
const SELECTED_QUEUE = 'supervisorSelectedQueue';

export const storeSelectedOperator = (
    selectedOperator: 'all' | OperatorKey,
) => {
    wrappedLocalStorage.setItem(SELECTED_OPERATOR, selectedOperator);
};

export const removeSelectedOperator = () => {
    return wrappedLocalStorage.removeItem(SELECTED_OPERATOR);
};

export const storeSelectedQueue = (selectedQueue: 'all' | QueueKey) => {
    wrappedLocalStorage.setItem(SELECTED_QUEUE, selectedQueue);
};

export const removeSelectedQueue = () => {
    return wrappedLocalStorage.removeItem(SELECTED_QUEUE);
};

export const getQueueAgentProfileEndTimeExpiringSoon = (
    profile: TypedMap<ActiveProfile>,
    timeThreshold: number,
) => {
    if (profile?.get('activeUntil')) {
        const activeUntil = new Date(profile.get('activeUntil'));

        const now = moment();
        const timeDuration = moment
            .duration(moment(activeUntil).diff(now))
            .asMilliseconds();

        // Only present countdown for profiles if the time slot will occur within the threshold
        if (timeDuration > timeThreshold) {
            return undefined;
        }
        return activeUntil.getTime();
    }
    return undefined;
};
